class Location {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
  }
}

export { Location };



// WEBPACK FOOTER //
// ./src/models/Location.js